var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.type === "DATE"
    ? _c("questionnaire-question-date", {
        attrs: {
          model: _vm.model,
          template: _vm.updatedTemplate,
          response: _vm.response,
        },
      })
    : _vm.type === "LIST"
    ? _c("questionnaire-question-list", {
        attrs: {
          model: _vm.model,
          template: _vm.updatedTemplate,
          response: _vm.response,
        },
      })
    : _c("questionnaire-question-text", {
        attrs: {
          model: _vm.model,
          template: _vm.updatedTemplate,
          response: _vm.response,
        },
      })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }